const Announcement = () => import(/* webpackChunkName: "announcement" */'@/components/pages/announcement/Announcement');
const OperateAnnouncementPage = () => import(/* webpackChunkName: "announcement" */'@/components/pages/announcement/OperateAnnouncementPage');
const AnnouncementDetail = () => import(/* webpackChunkName: "announcement" */'@/components/pages/announcement/AnnouncementDetail');

export default [
  {
    path: 'announcement-manage',
    name: 'announcementManage',
    meta: {
      title: '公告管理',
      roles: ['SYS_ANNOUNCEMENT_QUERY'],
      componentName: 'Announcement',
      breadcrumb: [
        {
          name: '公告管理',
          path: '/system/business/announcement-manage'
        }
      ]
    },
    component: Announcement
  },
  {
    path: 'edit-announcement/:id',
    props: true,
    name: 'editAnnouncement',
    meta: {
      title: '编辑公告',
      hidden: true,
      activeMenu: '/system/business/announcement-manage',
      roles: ['SYS_ANNOUNCEMENT_UPDATE'],
      componentName: 'OperateAnnouncementPage',
      breadcrumb: [
        {
          name: '公告管理',
          path: '/system/business/announcement-manage'
        },
        {
          name: '编辑公告',
          path: '/system/business/edit-announcement/:id'
        }
      ]
    },
    component: OperateAnnouncementPage
  },
  {
    path: 'create-announcement',
    name: 'createAnnouncement',
    meta: {
      title: '新建公告',
      hidden: true,
      activeMenu: '/system/business/announcement-manage',
      roles: ['SYS_ANNOUNCEMENT_ADD'],
      componentName: 'OperateAnnouncementPage',
      breadcrumb: [
        {
          name: '公告管理',
          path: '/system/business/announcement-manage'
        },
        {
          name: '新建公告',
          path: '/system/business/create-announcement'
        }
      ]
    },
    component: OperateAnnouncementPage
  },
  {
    path: 'announcement-detail/:id',
    props: true,
    name: 'announcementDetail',
    meta: {
      title: '公告详情',
      hidden: true,
      activeMenu: '/system/business/announcement-manage',
      roles: ['SYS_ANNOUNCEMENT_DETAIL_QUERY'],
      componentName: 'AnnouncementDetail',
      breadcrumb: [
        {
          name: '公告管理',
          path: '/system/business/announcement-manage'
        },
        {
          name: '公告详情',
          path: '/system/business/announcement-detail/:id'
        }
      ]
    },
    component: AnnouncementDetail
  }
];



// WEBPACK FOOTER //
// ./src/router/announcement.js